// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"8bb11ccb","812":"2712d59a"}[chunkId] + ".chunk.css";
};